import { useQuery } from '@tanstack/react-query'
import { getSubtitleFont } from 'service/list'

function useGetSubtitleFont() {
  return useQuery({
    queryKey: ['get-subtitle-font'],
    queryFn: () => getSubtitleFont(),
    staleTime: 6 * 1000,
  })
}

export default useGetSubtitleFont
